import {
  getHumanReadableDiffInPastDateWithAgo,
  getHumanReadableDurationInDate,
} from "./UtilsFunctions";
import { formatOnsetDurationForPdf } from "../HistoriesData/durationUtils";

export const formatHistoryOnsetForPdf = (
  item,
  onsetDateKey = "onset_datetime",
  onsetValueKey = "condition_onset",
  onsetTypeKey = "condition_onset_type"
) => {
  if (item?.[onsetDateKey]) {
    return formatOnsetDurationForPdf(
      getHumanReadableDiffInPastDateWithAgo(item[onsetDateKey], item)
    );
  }
  if (item?.[onsetValueKey]) {
    const combined = String(item[onsetValueKey] || "").trim();
    if (/\d+\s+[a-zA-Z]+/.test(combined)) {
      return formatOnsetDurationForPdf(`${combined} ago`);
    }
    return formatOnsetDurationForPdf(
      `${combined} ${item?.[onsetTypeKey] || ""} ago`.trim()
    );
  }
  return "-";
};

export const formatHistoryDurationForPdf = (
  item,
  onsetDateKey = "onset_datetime",
  abatementDateKey = "abatement_datetime",
  durationValueKey = "condition_duration",
  durationTypeKey = "condition_duration_type"
) => {
  if (item?.[abatementDateKey] && item?.[onsetDateKey]) {
    return formatOnsetDurationForPdf(
      getHumanReadableDurationInDate(
        item[onsetDateKey],
        item[abatementDateKey],
        item
      )
    );
  }
  if (item?.[durationValueKey]) {
    const combined = String(item[durationValueKey] || "").trim();
    if (/\d+\s+[a-zA-Z]+/.test(combined)) {
      return formatOnsetDurationForPdf(combined);
    }
    return formatOnsetDurationForPdf(
      `${combined} ${item?.[durationTypeKey] || ""}`.trim()
    );
  }
  return "-";
};
